/**
 * A FAIXA AMARELA DO TREINAMENTO.
 *
 * Ela fica FORA das rotas, acima de tudo, e por isso aparece em **toda** tela sem ninguém
 * precisar lembrar dela em cada uma. Tela nova herda a faixa do mesmo jeito que herda a barra de
 * cima: é a única forma que não depende de memória de gente.
 *
 * **Quem decide se ela aparece é o servidor**, pela sessão, e não o endereço da página. Faixa
 * decidida por `?treinamento=1` é faixa que não aparece quando importa: basta a pessoa recarregar
 * sem a pergunta, ou guardar o endereço sem ela, e o aviso some justamente no dia em que alguém
 * vai lançar achando que é de verdade.
 *
 * **Ela não sai no papel**, e isso é escolhido. O painel esconde a barra de cima do PDF de
 * propósito (`so-tela`), porque barra atravessada num relatório da tesouraria é tinta gasta. Aqui
 * a regra é a mesma: o que o painel gera é relatório para olhar, e o papel que vale é o do
 * notebook. **No notebook a decisão é a contrária**, e está pedida na lista de lá: lá o
 * fechamento IMPRIME, e um papel de treinamento assinado por engano é pior do que tinta gasta.
 */
import type { JSX } from 'react'
import type { Eu } from '../api'

export function FaixaDoTreinamento({
  eu,
  aoSair
}: {
  eu: Eu
  /** Volta para o Campo de verdade. A faixa é o único lugar que existe em toda tela. */
  aoSair: () => void
}): JSX.Element | null {
  if (!eu.treinamento) return null

  return (
    <div className="faixa-treinamento so-tela" role="status">
      <strong>TREINAMENTO</strong>
      <span className="o-que-e">
        nada daqui vale{eu.campo_que_estou_vendo === null ? '' : ` · ${eu.campo_que_estou_vendo}`}
      </span>
      <button type="button" className="sair-do-treinamento" onClick={aoSair}>
        Voltar ao Campo de verdade
      </button>
    </div>
  )
}
